import React from 'react'

import { WIDGET_CONFIGS } from '../edit/widget/_configs'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useOpenSelectIntegrationModal } from '../../../utils/routes/modals/modalsActions'
import BigCardPicker from '../../../packages/kiti/components/form/BigCardPicker'
import { without } from 'ramda'
import { TWILIO_WIDGET } from '../_services/twilio/_widget'
import { useSessionPermission } from '@btime/react-session'

const ServicesList = props => {
  const onSelect = useOpenSelectIntegrationModal()
  const data = useModalData()
  const canUseTwilioIntegration = useSessionPermission('canUseTwilioIntegration')

  const widgets = canUseTwilioIntegration ? WIDGET_CONFIGS : without([TWILIO_WIDGET], WIDGET_CONFIGS)

  return <BigCardPicker onChange={({ service }) => onSelect({ service, ...data })} options={widgets} />
}

export default ServicesList
